@use '@lib/assets/styles/main.scss' as *;

.syncedLeftIconClassName {
  color: $success900 !important;
}
